export const PromotionBannerModuleName = 'Promotion Banner';
